app.controller("LecturerGradesController", [
    "$scope", "$rootScope", "Students", "$uibModal", "$stateParams", "AuthService", "LecturerService", "$state", "toastr", "StaticData", "usSpinnerService",
    function ($scope, $rootScope, Students, $uibModal, $stateParams, AuthService, LecturerService, $state, toastr, StaticData, usSpinnerService) {
        var lecturerId;
        var subjectId = $stateParams.subject;
        var rawData = null;
        $scope.sessionGroups = [{_id: null, name: "ყველა"}];
        $scope.sessionGroup = null;
        $scope.selectedComponent = "";
        $scope.componentList = null;
        $scope.filteredSelections = null;
        $scope.groupOpenStates = {};
        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === "lecturer" && p.state === 'active'
            })[0];
            $scope.user = user;
            lecturerId = $scope.profile._id;
            fetchGroups();
        });

        function fetchGroups() {
            StaticData.getItemsByKey("session_types").then(function (sessionTypes) {
                $scope.sessionTypes = sessionTypes;
                $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
                StaticData.getItemsByKey("days").then(function (days) {
                    $scope.days = days;
                    $scope.daysMap = _.keyBy($scope.days, '_id');

                    LecturerService.subjectGroups({subjectId: subjectId, lecturerId: lecturerId}).then(function (data) {
                        _(data).each(function (group) {
                            group.type = $scope.sessionTypesMap[group.sessionType].name;
                            group.days = _(group.sessions).filter(function (session) {
                                return session.hasOwnProperty('dayOfWeek');
                            }).map('dayOfWeek').map(function (day) {
                                return $scope.daysMap[day].name;
                            }).uniq().value().join(', ');
                            group.name = (group.title && group.title.length ? group.title : group.type) + " - " + group.days;
                        });
                        $scope.sessionGroups = $scope.sessionGroups.concat(data.map(function (el) {
                            return {
                                _id: el._id,
                                name: el.name
                            };
                        }));
                        fetchSelections();
                    });
                });

            });
        }

        function formatComponentOptions(gradeTemplate) {
            if ($scope.componentList) return;
            $scope.componentList = gradeTemplate.components.filter(function (el) {
                return el.type !== "group";
            });
        }

        $scope.filterGroups = function () {
            fetchSelections();
        };

        $scope.filterComponents = function () {
            if ($scope.selectedComponent === "") return;

            $scope.filteredSelections = rawData.selections.map(function (el) {
                var component = el.unorderedGrades.filter(function (c) {
                    return c._id === $scope.selectedComponent;
                })[0];
                return {profile: el.profile, component: component};
            });
        };

        function fetchSelections() {
            usSpinnerService.spin("root");
            LecturerService.selectionList({
                lecturerId: lecturerId,
                subjectId: subjectId,
                sessionGroup: $scope.sessionGroup
            }).then(function (data) {
                rawData = data;
                $scope.subject = data.subject;
                $scope.selections = data.selections;
                $scope.selectionsMap = _.keyBy($scope.selections, function (item) {
                  return item._id;
                });
                formatComponentOptions(data.gradeTemplate);
                $scope.filterComponents();
                $scope.emails = "";
                $scope.selections.forEach(function (sel) {
                    if(sel.profile.user.email) {
                        $scope.emails += sel.profile.user.email + ', ';
                    }
                });
                $scope.emails = $scope.emails.substring(0, $scope.emails.length - 2);
                usSpinnerService.stop("root");
            });
        }

        $scope.exportStudents = function() {
            LecturerService.exportSelectionStudents({
                lecturerId: lecturerId,
                subjectId: subjectId,
                sessionGroup: $scope.sessionGroup ? $scope.sessionGroup : ''
            });
        };

        var messages = {
            nan: "შეყვანილი მნიშვნელობა არაა ქულა",
            more: "ქულა მეტია დასაშვებზე",
            less: "ქულა არ შეიძლება იყოს უარყოფითი",
            right: "თქვენ არ გაქვთ მოცემული ქულის რედაქტირების უფლება",
            locked: "ამ ეტაპისთვის მოცემულ კომპონენტზე ქულის დაწერა შეზღუდულია"
        };

        function addGrade(grade) {
            if (!grade.grade || isNaN(grade.grade.relative) || grade.grade.relative === "") {
                return toastr.warning(messages.nan);
            }
            if (grade.grade.relative > grade.relative) {
                return toastr.warning(messages.more);
            }
            if (grade.grade.relative < 0) {
                return toastr.warning(messages.less);
            }
            grade.pending = true;
            LecturerService.addGrade({
                lecturerId: lecturerId,
                relative: grade.grade.relative,
                gradeComponent: grade._id,
                subjectSelection: grade.selection
            }).then(function (data) {
                if (data.status === "success") {
                    // grade.pending = false;
                    toastr.success("ქულა დამატებულია");
                    $scope.onGradeCursorRemove();
                    fetchSelections();
                }
            }).catch(function (reason) {
                toastr.warning(messages[reason.data.message]);
                grade.pending = false;
            });
        }

        function editGrade(grade) {
            $uibModal.open({
                controller: "EditGradeController",
                templateUrl: _pb + 'lecturer/edit-grade.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {grade: grade};
                    }
                }
            }).result
                .then(function (result) {
                    if (isNaN(result.value) || result.value === "") {
                        return toastr.warning(messages.nan);
                    }
                    if (result.value > grade.relative) {
                        return toastr.warning(messages.more);
                    }
                    if (result.value < 0) {
                        return toastr.warning(messages.less);
                    }

                    LecturerService.editGrade({
                        grade: grade.grade._id,
                        lecturerId: lecturerId,
                        relative: result.value,
                        comment: result.comment
                    }).then(function (data) {
                        if (data.status === "success") {
                            // grade.pending = false;
                            toastr.success("ქულა რედაქტირებულია");
                            fetchSelections();
                        }
                    }).catch(function (reason) {
                        toastr.warning(messages[reason.data.message]);
                    });
                }, function () {
                });
        }

        $scope.gradeDisabled = function (grade) {
          var gradeHasRight = !!grade.right; // ლექტორს არ აქვს შეცვლის უფლება თუ კომპონენტს ადევს უფლება

          var otherGradeInputIsNotEmpty = !!$scope.currentGrade && $scope.currentGrade !== grade;

          return gradeHasRight || otherGradeInputIsNotEmpty;
        };

        $scope.gradeLocked = function (grade) {
          var selection = $scope.selectionsMap[grade.selection];
          return selection.state !== 'current';
        };

        $scope.onGradeCursor = function (grade) {
          $scope.currentGrade = grade;
        };

        $scope.onGradeCursorRemove = function () {
          $scope.currentGrade = null;
        };

        function toggleGroupOpen(groupId, studentId) {
            var key = groupId + '-' + studentId;
            var previous = $scope.groupOpenStates[key] || false;
            $scope.groupOpenStates[key] = !previous;
        }

        function isGroupOpen(groupId, studentId) {
            var key = groupId + '-' + studentId;
            return $scope.groupOpenStates[key] || false;
        }

        $scope.gradeOptions = {
            add: addGrade,
            edit: editGrade,
            showDelete: false,
            delete: function(){},
            toggleGroupOpen: toggleGroupOpen,
            isGroupOpen: isGroupOpen,
        };

        $scope.copy = function () {
            var copyText = document.getElementById("emails");
            copyText.select();
            copyText.setSelectionRange(0, 99999)
            document.execCommand("copy");
        }

    }
]);
